module.exports = __webpack_public_path__ + "media/images/cliparts/deal 7-bf0db8738b0e5b0de4856ecb4882b99b.svg";